//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    computed: {
        show_jump() {
            const { message_type, details, jump_path } = this.item
            return jump_path || (details && details.image_url) || ['yesterday_score_journals', 'consultant_resign_apply'].indexOf(message_type) > -1
        },
        btn_text() {
            return this.item.message_type === 'yesterday_score_journals' ? "点击查看积分明细" : "点击查看"
        }
    },
    props: {
        item: Object
    }
}
